export enum DashboardInitUrlQuery {
  CLIENT_ID = 'clientId',
  VOUCHER_ID = 'voucherId',
  VOUCHER_EVENT = 'voucherEvent',
  SUBSCRIPTION_TYPE = 'subscriptionType',
  JUST_REGISTERED = 'justRegistered',
}
